// Skeleton Component
const SkeletonField = ({
  labelWidth,
  inputHeight = 'h-10',
  inputWidth = 'w-full',
}: {
  labelWidth: string;
  inputHeight?: string;
  inputWidth?: string;
}) => (
  <div>
    <div className={`h-5 bg-gray-200 rounded ${labelWidth} mb-1`}></div>
    <div
      className={`bg-gray-200 rounded-lg ${inputHeight} ${inputWidth}`}
    ></div>
  </div>
);

export const ServiceFormSkeleton = () => (
  <div className='max-w-2xl mx-auto space-y-6 animate-pulse'>
    <div className='h-8 bg-gray-200 rounded-lg w-3/4 mb-8'></div>

    <SkeletonField labelWidth='w-1/3' />
    <SkeletonField labelWidth='w-1/4' />
    <SkeletonField labelWidth='w-1/3' inputHeight='h-32' />
    <SkeletonField labelWidth='w-1/5' />
    <SkeletonField labelWidth='w-1/4' />
    <SkeletonField labelWidth='w-1/5' />
    <SkeletonField labelWidth='w-1/6' />
    <SkeletonField labelWidth='w-1/3' inputHeight='h-40' />

    <div className='flex justify-end'>
      <div className='h-10 bg-gray-200 rounded-lg w-32'></div>
    </div>
  </div>
);
